import { Column } from 'react-table';

export const useTable = ({ columns, data }: any) => {
  const fullColumns: Column[] = [...columns];

  return {
    fullColumns,
  };
};
